"use client";

import React from "react";
import ReportDrawer from "../landing-page/ReportDrawer";
import FeatureCircle from "../landing-page/FeatureCircle";
import featuresData from "../data/featuresData";

const PowerfulFeatures = () => {
  return (
    <section className="relative w-full max-w-full mx-auto py-8 md:py-12 lg:py-16 px-2 sm:px-3 md:px-4 bg-gray-100">
      {/* Report Drawer (hoverable side drawer) */}
      <ReportDrawer />

      {/* Section Header */}
      <div className="flex flex-col items-center mb-8 md:mb-10 text-black">
        <p className="text-blue-500 font-bold text-2xl uppercase -mt-1">
          Powerful Features
        </p>
        <p className="text-xl text-center mt-2 text-black">
          Here's all the good stuff
        </p>
      </div>

      {/* Features layout */}
      <div className="hidden lg:flex flex-wrap justify-around w-full relative z-10">
        {/* Top row */}
        <div className="flex justify-around w-full max-w-full mb-8 gap-8">
          {featuresData.slice(0, 3).map((feature, index) => (
            <FeatureCircle
              key={index}
              bgColor={feature.color}
              heading={feature.heading}
              description={feature.description}
              icon={feature.icon}
            />
          ))}
        </div>

        {/* Bottom row */}
        <div className="flex justify-around w-full max-w-full mt-[-3rem] gap-4 px-10">
          {featuresData.slice(3).map((feature, index) => (
            <FeatureCircle
              key={index + 3}
              bgColor={feature.color}
              heading={feature.heading}
              description={feature.description}
              icon={feature.icon}
            />
          ))}
        </div>
      </div>

      {/* Small screens: stacked layout */}
      <div className="flex flex-col items-center lg:hidden relative z-10">
        {featuresData.map((feature, index) => (
          <div key={index} className="mb-6">
            <FeatureCircle
              bgColor={feature.color}
              heading={feature.heading}
              description={feature.description}
              icon={feature.icon}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PowerfulFeatures;
